import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.014 15.85C6.404 15.85 4.72 15.368 4.067 15.105C4.235 13.722 4.926 10.257 7.584 8.966C8.315 9.543 9.217 9.9 10.207 9.9C11.122 9.9 11.969 9.603 12.669 9.103C15.126 10.477 15.796 13.75 15.96 15.097C15.277 15.376 13.591 15.85 10.014 15.85ZM10.207 3C11.493 3 12.538 4.099 12.538 5.45C12.538 6.801 11.493 7.9 10.207 7.9C8.922 7.9 7.876 6.801 7.876 5.45C7.876 4.099 8.922 3 10.207 3ZM18.013 15.617C18.005 15.371 17.778 9.943 14.007 7.54C14.335 6.914 14.538 6.209 14.538 5.45C14.538 2.996 12.595 1 10.207 1C7.82 1 5.876 2.996 5.876 5.45C5.876 6.142 6.044 6.79 6.32 7.375C2.271 9.678 2.023 15.365 2.015 15.617L2 16.052L2.309 16.359C2.66 16.709 4.256 17.85 10.014 17.85C15.772 17.85 17.368 16.709 17.719 16.359L18.028 16.052L18.013 15.617Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
